import { render } from "./Lawson.vue?vue&type=template&id=7399b9a8"
import script from "./Lawson.vue?vue&type=script&setup=true&lang=js"
export * from "./Lawson.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/blogs/Lawson.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7399b9a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7399b9a8', __exports__)) {
    api.reload('7399b9a8', __exports__)
  }
  
  module.hot.accept("./Lawson.vue?vue&type=template&id=7399b9a8", () => {
    api.rerender('7399b9a8', render)
  })

}


export default __exports__